
import React from 'react';
import Kindergarten from 'views/Kindergarten';

const KindergartenPage = () => {
  return <Kindergarten/>;
};

export default KindergartenPage;
